var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.25H3.75C3.0625 1.25 2.5 1.8125 2.5 2.5V12.5C2.5 13.1875 3.0625 13.75 3.75 13.75H11.25C11.9375 13.75 12.5 13.1875 12.5 12.5V2.5C12.5 1.8125 11.9375 1.25 11.25 1.25ZM3.75 2.5H6.875V7.5L5.3125 6.5625L3.75 7.5V2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.a632abf1c853ae6323a658cdb82eeda1.svg";
export { ForwardRef as ReactComponent };